import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { ref, onMounted } from "vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'TimerDisplay',
  setup(__props) {

const gmtTime = ref("");
const hongKongTime = ref("");
const sydneyTime = ref("");
const usEasternTime = ref("");
const jpTime = ref("");
const updateTimeZones = () => {
  const now = new Date();
  gmtTime.value = new Intl.DateTimeFormat("en-GB", {
    timeStyle: "medium",
    timeZone: "GMT",
  }).format(now);

  hongKongTime.value = new Intl.DateTimeFormat("en-GB", {
    timeStyle: "medium",
    timeZone: "Asia/Hong_Kong",
  }).format(now);

  sydneyTime.value = new Intl.DateTimeFormat("en-GB", {
    timeStyle: "medium",
    timeZone: "Australia/Sydney",
  }).format(now);

  usEasternTime.value = new Intl.DateTimeFormat("en-GB", {
    timeStyle: "medium",
    timeZone: "America/Los_Angeles",
  }).format(now);
  jpTime.value = new Intl.DateTimeFormat("en-GB", {
    timeStyle: "medium",
    timeZone: "Asia/Tokyo",
  }).format(now);
};

let intervalId;

onMounted(() => {
  updateTimeZones();
  intervalId = setInterval(updateTimeZones, 1000); // Update every second
});

return (_ctx: any,_cache: any) => {
  const _component_el_tag = _resolveComponent("el-tag")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_tag, {
      effect: "dark",
      class: "tag"
    }, {
      default: _withCtx(() => [
        _createTextVNode("GMT: " + _toDisplayString(gmtTime.value), 1)
      ]),
      _: 1
    }),
    _createVNode(_component_el_tag, {
      effect: "dark",
      class: "tag",
      type: "success"
    }, {
      default: _withCtx(() => [
        _createTextVNode("HK: " + _toDisplayString(hongKongTime.value), 1)
      ]),
      _: 1
    }),
    _createVNode(_component_el_tag, {
      effect: "dark",
      class: "tag",
      type: "info"
    }, {
      default: _withCtx(() => [
        _createTextVNode("SYD: " + _toDisplayString(sydneyTime.value), 1)
      ]),
      _: 1
    }),
    _createVNode(_component_el_tag, {
      effect: "dark",
      class: "tag",
      type: "warning"
    }, {
      default: _withCtx(() => [
        _createTextVNode("LA: " + _toDisplayString(usEasternTime.value), 1)
      ]),
      _: 1
    }),
    _createVNode(_component_el_tag, {
      effect: "light",
      class: "tag"
    }, {
      default: _withCtx(() => [
        _createTextVNode("JP: " + _toDisplayString(jpTime.value), 1)
      ]),
      _: 1
    })
  ]))
}
}

})